export default __webpack_public_path__ + "static/media/Claro.0baaefc4.png";